import { NgModule } from "@angular/core";
import { CustomTranslationPipe } from "../pipes/custom-translation.pipe";

@NgModule({
    imports: [],
    declarations: [CustomTranslationPipe],
    exports: [CustomTranslationPipe]
})
export class TranslationModule { }